export const popover = {
  popover: {
    contentPadding: '.25rem 0',
  },
};
